import React, {
  Component,
  ChangeEvent,
  InputHTMLAttributes,
  RefObject
} from "react";
import styled from "styled-components";
import { colors, fontSizing, spacing } from "../../theme";

export const InputWrap = styled.div`
  position: relative;
  letter-spacing: normal;
`;
export const Error = styled.div<{ isError?: boolean }>`
  display: flex;
  align-items: center;
  gap: 9px;
  color: ${p => (p.isError ? colors.white : colors.darkgrey)};
  background: ${p => p.isError && colors.monza};
  ${fontSizing("label", 20)}
  ${spacing("margin-top", 8)}
  font-weight:400;
  padding: 8px 16px;
  &:before {
    content: "";
    display: block;
    width: 19px;
    height: 19px;
    background-image: url("data:image/svg+xml,%3Csvg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.49987 13.0215C8.96869 13.0215 8.52344 13.4667 8.52344 13.9979C8.52344 14.5291 8.96869 14.9744 9.49987 14.9744C10.0115 14.9744 10.4763 14.5291 10.4529 14.0214C10.4763 13.4628 10.035 13.0215 9.49987 13.0215Z' fill='white'/%3E%3Cpath d='M18.5377 16.4823C19.1509 15.4239 19.1548 14.1623 18.5455 13.1078L12.4291 2.5154C11.8237 1.44914 10.7301 0.816406 9.50367 0.816406C8.27727 0.816406 7.18366 1.45304 6.57827 2.5115L0.454061 13.1156C-0.155235 14.1819 -0.151329 15.4512 0.465779 16.5097C1.07507 17.5564 2.16478 18.1852 3.38337 18.1852H15.6005C16.823 18.1852 17.9205 17.5486 18.5377 16.4823ZM17.2097 15.7168C16.8699 16.3027 16.2684 16.6503 15.5966 16.6503H3.37946C2.71549 16.6503 2.11791 16.3105 1.78592 15.7363C1.45003 15.1544 1.44612 14.4592 1.78201 13.8733L7.90622 3.27312C8.23821 2.69116 8.83188 2.34746 9.50367 2.34746C10.1716 2.34746 10.7691 2.69507 11.1011 3.27702L17.2214 13.8772C17.5495 14.4475 17.5456 15.1349 17.2097 15.7168Z' fill='white'/%3E%3Cpath d='M9.25771 6.16819C8.79293 6.30099 8.50391 6.72281 8.50391 7.23446C8.52734 7.54301 8.54687 7.85547 8.5703 8.16403C8.6367 9.33966 8.7031 10.4919 8.7695 11.6675C8.79293 12.0659 9.10149 12.3549 9.49987 12.3549C9.89826 12.3549 10.2107 12.0463 10.2302 11.644C10.2302 11.4019 10.2302 11.1793 10.2537 10.9332C10.2966 10.1794 10.3435 9.42558 10.3865 8.67177C10.4099 8.18355 10.4529 7.69534 10.4763 7.20712C10.4763 7.03136 10.4529 6.87513 10.3865 6.7189C10.1873 6.28146 9.7225 6.05883 9.25771 6.16819Z' fill='white'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: cover;
  }
`;

export const StyledInput = styled.input<{ error?: boolean }>`
  height: 71px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  ${spacing("padding-top", 32)}
  ${spacing("padding-bottom", 32)}
  ${spacing("padding-left", 48)}
  ${spacing("padding-right", 48)}

  ${fontSizing("label", 20)}
  color: ${p => (p.error ? colors.errorRed : colors.blue)};
  background: #fff;

  border-radius: 5px;
   &:hover, &:focus{
   border: 1px solid ${colors.calypso}
  }

  &[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &[readOnly] {
    color: ${colors.darkgrey};
    cursor: not-allowed;
  }
  &::placeholder {
    color: ${colors.pigeon};
    font-size: 1em;
  }
  /* - Chrome ≤56,
   - Safari 5-10.0
   - iOS Safari 4.2-10.2
   - Opera 15-43
   - Opera Mobile 12-12.1
   - Android Browser 2.1-4.4.4
   - Samsung Internet ≤6.2
   - QQ Browser */
::-webkit-input-placeholder {
    color: ${p => (p.error ? colors.errorRed : colors.blue)};
    font-weight: 400;
}

/* Firefox 4-18 */
:-moz-placeholder {
    color: ${p => (p.error ? colors.errorRed : colors.blue)};
    font-weight: 400;
}

/* Firefox 19-50 */
::-moz-placeholder {
    color: ${p => (p.error ? colors.errorRed : colors.blue)};
    font-weight: 400;
}

/* - Internet Explorer 10–11
   - Internet Explorer Mobile 10-11 */
:-ms-input-placeholder {
    color: ${p => (p.error ? colors.errorRed : colors.blue)} !important;
    font-weight: 400 !important;
}

/* Edge (also supports ::-webkit-input-placeholder) */
::-ms-input-placeholder {
    color: ${p => (p.error ? colors.errorRed : colors.blue)};
    font-weight: 400;
}

/* CSS Pseudo-Elements Level 4 Editor's Draft
   - Browsers not mentioned in vendor prefixes
   - Browser of newer versions than mentioned in vendor prefixes */
::placeholder {
    color: ${p => (p.error ? colors.errorRed : colors.blue)};
    font-weight: 400;
}
`;

export const Label = styled.label<{ disabled?: boolean; readOnly?: boolean }>`
  color: ${p =>
    p.disabled
      ? colors.whiteThree
      : p.readOnly
      ? colors.darkgrey
      : colors.darkgrey};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${fontSizing("label", 24)}
  ${spacing("margin-bottom", 24)}
  display:block;
`;
export const InfoSpan = styled.span<{ disabled?: boolean; readOnly?: boolean }>`
  color: ${p =>
    p.disabled
      ? colors.whiteThree
      : p.readOnly
      ? colors.darkgrey
      : colors.grey};
  margin-left: 1ch;
`;
export type Props = InputHTMLAttributes<HTMLInputElement> & {
  error?: string;
  label?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
  children?: any;
  field?: any;
  info?: string;
  inputRef?: RefObject<HTMLInputElement>;
  controlledInputValue?: string;
  placeholderText?: string;
};

interface State {
  value: string;
  hasValue: boolean;
  focus?: boolean;
}

export default class Input extends Component<Props, State> {
  state: State = {
    value: "",
    hasValue: false,
    focus: false
  };

  constructor(props, context) {
    super(props, context);
    const { value, defaultValue, onChange, controlledInputValue } = props;
    this.state.value = value || defaultValue || controlledInputValue || "";
    this.state.hasValue = !!this.state.value;
    this._onBlur = this._onBlur.bind(this);
    this._onFocus = this._onFocus.bind(this);
    // TODO Add check if dev environment to if statement
    if (controlledInputValue !== undefined && !onChange)
      console.error(
        "controlledInputValue prop requires that an onChange prop also be included"
      );
  }

  _onBlur() {
    setTimeout(() => {
      if (this.state.focus) {
        this.setState({
          focus: false
        });
      }
    }, 0);
  }
  _onFocus() {
    if (!this.state.focus) {
      this.setState({
        focus: true
      });
    }
  }

  handleChange = ev => {
    const { onChange, controlledInputValue } = this.props;
    if (!controlledInputValue || !onChange)
      this.updateStateValue(ev.target.value);
    if (onChange) onChange(ev, ev.target.value);
  };

  updateStateValue(value: string) {
    this.setState(() => ({ hasValue: value !== "", value }));
  }

  // On value change via props, check whether to float label
  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (this.props.value !== prevProps.value) {
      this.setState({
        hasValue: value !== "",
        value: (value && value.toString()) || ""
      });
    }
  }

  // Check if the parent wants to update the input value
  componentWillUpdate({ controlledInputValue }: Props) {
    const oldValue = this.props.controlledInputValue;
    if (controlledInputValue !== undefined && oldValue !== controlledInputValue)
      this.updateStateValue(controlledInputValue);
  }

  render() {
    const {
      value, // define here so it doesn't get copied in 'inputProps'
      error,
      label,
      info,
      children,
      inputRef,
      controlledInputValue,
      disabled,
      readOnly,
      placeholderText,
      ...inputProps
    } = this.props;
    const ref = inputRef;
    const val =
      typeof controlledInputValue === "string"
        ? controlledInputValue
        : this.state.value;

    return (
      <>
        <InputWrap>
          {(label || info) && (
            <Label
              disabled={disabled}
              readOnly={readOnly}
              htmlFor={inputProps.id}
            >
              {label && label}
            </Label>
          )}
          <StyledInput
            {...inputProps}
            value={val}
            onChange={this.handleChange}
            ref={ref}
            disabled={disabled}
            readOnly={readOnly}
            error={!!error}
            placeholder={this.state.focus ? "" : placeholderText}
            onFocus={this._onFocus}
            onBlur={this._onBlur}
          />
          {children}

          {(error || info) && (
            <Error
              id={inputProps.id ? `${inputProps.id}-error` : undefined}
              isError={!!error}
            >
              {info ? info : error}
            </Error>
          )}
        </InputWrap>
      </>
    );
  }
}
